/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type useNflReferenceQueryVariables = {||};
export type useNflReferenceQueryResponse = {|
  +whoAmI: ?{|
    +username: string,
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>,
  |},
  +nflStatSeasons: ?$ReadOnlyArray<?{|
    +id: string,
    +year: number,
    +current: boolean,
    +nflstatweekSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +week: number,
          +current: boolean,
        |}
      |}>
    |},
  |}>,
  +nflStatTeams: ?$ReadOnlyArray<?{|
    +id: string,
    +city: ?string,
    +name: ?string,
    +abbreviation: string,
    +primaryColorHex: ?string,
    +logoSrc: ?string,
  |}>,
|};
export type useNflReferenceQuery = {|
  variables: useNflReferenceQueryVariables,
  response: useNflReferenceQueryResponse,
|};
*/


/*
query useNflReferenceQuery {
  whoAmI {
    username
    groups {
      name
    }
    id
  }
  nflStatSeasons {
    id
    year
    current
    nflstatweekSet(first: 30) {
      edges {
        node {
          week
          current
          id
        }
      }
    }
  }
  nflStatTeams {
    id
    city
    name
    abbreviation
    primaryColorHex
    logoSrc
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "week",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "NFLStatTeamType",
  "kind": "LinkedField",
  "name": "nflStatTeams",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "abbreviation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryColorHex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoSrc",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useNflReferenceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLStatSeasonType",
        "kind": "LinkedField",
        "name": "nflStatSeasons",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "NFLStatWeekTypeConnection",
            "kind": "LinkedField",
            "name": "nflstatweekSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatWeekTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NFLStatWeekType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "nflstatweekSet(first:30)"
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useNflReferenceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLStatSeasonType",
        "kind": "LinkedField",
        "name": "nflStatSeasons",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "NFLStatWeekTypeConnection",
            "kind": "LinkedField",
            "name": "nflstatweekSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatWeekTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NFLStatWeekType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "nflstatweekSet(first:30)"
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ]
  },
  "params": {
    "cacheID": "574c497075e4023a597c30665a29cdac",
    "id": null,
    "metadata": {},
    "name": "useNflReferenceQuery",
    "operationKind": "query",
    "text": "query useNflReferenceQuery {\n  whoAmI {\n    username\n    groups {\n      name\n    }\n    id\n  }\n  nflStatSeasons {\n    id\n    year\n    current\n    nflstatweekSet(first: 30) {\n      edges {\n        node {\n          week\n          current\n          id\n        }\n      }\n    }\n  }\n  nflStatTeams {\n    id\n    city\n    name\n    abbreviation\n    primaryColorHex\n    logoSrc\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7532d36cfd174e7ae6d6570ff476d732';

module.exports = node;
